module.exports = __webpack_public_path__ + "img/4.c56f735.png";